import request from '../request';
import requestUrl from '../requestUrl';
import requestParam from '../requestParam';
import { serviceWithHeader } from '../request'

// 获取entityList--平铺
export const queryEntityList = params => {
    return request({
        url: requestUrl('/clientEntity/queryEntityList'),
        method: 'post',
        data: requestParam(params)
    });
};

// 获取site下的client用户
export const queryClientUserList = params => {
    return request({
        url: requestUrl('/manage/clientUser/query'),
        method: 'post',
        data: requestParam(params)
    });
};

//获取site下的kpmg用户
export const queryKpmgUserList = params => {
    return request({
        url: requestUrl('/site/member/query'),
        method: 'post',
        data: requestParam(params)
    });
};

// 新增
export const exchangeAdd = params => {
    return request({
        url: requestUrl('/siteEntity/add'), ///    /siteEntity/{id}
        method: 'post',
        data: requestParam(params)
    });
};

//查询
export const exchangeQuery = params => {
    return request({
        url: requestUrl('/client/siteEntity/querySiteEntity'),
        method: 'post',
        data: requestParam(params)
    });
};

// 修改
export const exchangeUpdate = params => {
    return request({
        url: requestUrl('/siteEntity/update'),
        method: 'post',
        data: requestParam(params)
    });
};

// 删除
export const exchangeDel = id => {
    return request({
        url: requestUrl(`/siteEntity/${id}`),
        method: 'delete'
    })
}
// 批量删除
export const batchDelete = (params) => {
    return request({
        url: requestUrl(`/siteEntity/batchDelete`),
        method: 'delete',
        data: requestParam(params)
    })
}

// 批量下载
export const checkBatchDownloadRight = params => {
    return request({
        url: requestUrl('/client/pbcGroup/checkBatchExDownloadRight'),
        method: 'post',
        data: requestParam(params)
    });
};


export const downloadExMultipleFilesAsZip = params => {
    return serviceWithHeader({
        url: requestUrl('/file/free/downloadExMultipleFilesAsZip'),
        method: 'post',
        data: params,
        responseType:'blob'
    });
};

// 发送邮件
export const sendEmail = params => {
    return request({
        url: requestUrl('/siteEntity/sendFileNotificationEmail'),
        method: 'post',
        data: requestParam(params)
    });
};
// 查询status
export const queryStatus = params => {
    return request({
        url: requestUrl('/client/siteEntity/queryExchangeStatus'),
        method: 'post',
        data: requestParam(params)
    });
};

// 更改status
export const changeStatus = params => {
    return request({
        url: requestUrl('/siteEntity/changeStatus'),
        method: 'post',
        data: requestParam(params)
    });
};

//查询修改记录
export const queryStatusModify = params => {
    return request({
        url: requestUrl('/statusModifyRecord/queryStatusModify'),
        method: 'post',
        data: requestParam(params)
    });
};

//更改kpmgUser
export const changeKpmgUser = params => {
    return request({
        url: requestUrl('/siteEntity/updatePersonInCharge'),
        method: 'post',
        data: requestParam(params)
    });
};

//更改截止日期(集团确认的截止日期)
export const changeDueDay = params => {
    return request({
        url: requestUrl('/siteEntity/changeDueDay'),
        method: 'post',
        data: requestParam(params)
    });
};

// 更改组成部分确认的截止日期
export const changeConfirmDueDay = params => {
    return request({
        url: requestUrl('/siteEntity/changeConfirmDueDay'),
        method: 'post',
        data: requestParam(params)
    });
};

// 设置逾期邮件通知
export const setDuedayAlarmConfig = params => {
    return request({
        url: requestUrl('/siteConfig/setDuedayAlarmConfig'),
        method: 'post',
        data: requestParam(params)
    });
};

//category option 查询
export const searchCategory = params => {
    return request({
        url: requestUrl('/siteEntity/searchCategory'),
        method: 'post',
        data: requestParam(params)
    });
};

//is Component Member search
export const queryIfKpMember = params => {
    return request({
        url: requestUrl('/client/site/queryIfKpMember'),
        method: 'post',
        data: requestParam(params)
    });
};


//批量修改status
export const batchSetStatus = params => {
    return request({
        url: requestUrl('/siteEntity/batchSetStatus'),
        method: 'post',
        data: requestParam(params)
    });
};


//批量修改deadline
export const batchSetDeadline = params => {
    return request({
        url: requestUrl('/siteEntity/batchSetDeadline'),
        method: 'post',
        data: requestParam(params)
    });
};


//批量修改responsible
export const batchSetResponsible = params => {
    return request({
        url: requestUrl('/siteEntity/batchSetResponsible'),
        method: 'post',
        data: requestParam(params)
    });
};


// 一键更新至所有client roles
export const reverseCategory = params => {
    return request({
        url: requestUrl('/client/siteEntity/reverseCategory'),
        method: 'post',
        data: requestParam(params)
    })
}
export const exportList = params => {
    return serviceWithHeader({
        url: requestUrl('/client/siteEntity/export'),
        method: 'post',
        data: requestParam(params),
        responseType: 'blob'
    })
}
export const getItaList = params => {
    return request({
        url: requestUrl('/summary/queryPage'),
        method: 'post',
        data: requestParam(params)
    })
}
export const itaAdd = params => {
    return request({
        url: requestUrl('/summary/add'),
        method: 'post',
        data: requestParam(params)
    })
}

export const itaBatchUpdate = params => {
    return request({
        url: requestUrl('/summary/batchUpdate'),
        method: 'post',
        data: requestParam(params)
    })
}
export const itaUpdate = params => {
    return request({
        url: requestUrl('/summary/update'),
        method: 'post',
        data: requestParam(params)
    })
}
export const itaDetail = params => {
    return request({
        url: requestUrl('/summary/detail'),
        method: 'post',
        data: requestParam(params)
    })
}
export const querySelectList = params => {
    return request({
        url: requestUrl('/summary/querySelectList'),
        method: 'post',
        data: requestParam(params)
    })
}
export const saveAnswer = params => {
    return request({
        url: requestUrl('/summary/saveAnswer'),
        method: 'post',
        data: requestParam(params)
    })
}

export const uploadItuFiles = params => {
    return request({
        url: requestUrl('/client/pbcGroup/uploadItuFiles'),
        method: 'post',
        data: params,
        timeout: 900000,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};

export const deleteFile = params => {
    return request({
        url: requestUrl('/summary/deleteFile'),
        method: 'post',
        data: requestParam(params)
    })
}
export const deleteItu = params => {
    return request({
        url: requestUrl('/summary/delete'),
        method: 'post',
        data: requestParam(params)
    })
}
export const ituExportZip = params => {
    return serviceWithHeader({
        url: requestUrl('/summary/exportZip'),
        method: 'post',
        data: params,
        responseType:'blob'
    });
};
export const sendItuFileNotifyEmail = params => {
    return request({
        url: requestUrl('/summary/sendItuFileNotifyEmail'),
        method: 'post',
        data: requestParam(params)
    })
}

// {
//     "summaryId": "239316089a277be934491270b1f28c1d",
//     "questionId": "1",
//     "message": "eeeeeeeee"
//  }
export const ituSendMessage = params => {
    return request({
        url: requestUrl('/summary/message'),
        method: 'post',
        data: requestParam(params)
    })
}

// {
//     "ids": [
//         "68d2065254ea6ae60088e4e06669890c"
//     ]
//  }
export const ituDeleteMessage = params => {
    return request({
        url: requestUrl('/summary/message'),
        method: 'delete',
        data: requestParam(params)
    })
}

// {
//     "id": "c925986d0caa4fe5c9793256559bcb68",
//     "message": "77777777777777778"
//  }
export const ituEditMessage = params => {
    return request({
        url: requestUrl('/summary/message'),
        method: 'put',
        data: requestParam(params)
    })
}

// /summary/message?summaryId=239316089a277be934491270b1f28c1d
export const ituGetMessageList = params => {
    return request({
        url: requestUrl('/summary/message'),
        method: 'get',
        data: requestParam(params)
    })
}
export const downloadItuFiles = params => {
    return request({
        url: requestUrl('/file/free/downloadGet'),
        method: 'post',
        data: requestParam(params),
        responseType: 'blob'
    });
};

export const queryTodayCommentInfos = params => {
    return request({
        url: requestUrl('/client/siteEntity/queryTodayCommentInfos'),
        method: 'post',
        data: requestParam(params)
    })
}

// 获取饼图信息
export const getPieData = (params) => {
    return request({
        url: requestUrl('/client/siteEntity/siteEntityDashBoard'),
        method: 'post',
        data: requestParam(params)
    })
}

// 获取表格信息
export const getDashTable = (params) => {
    return request({
        url: requestUrl('/client/siteEntity/siteEntityListView'),
        method: 'post',
        data: requestParam(params)
    })
}
